const funcReload = (() => {



  // ページのスクロール位置の復元を手動に設定します。
  // これにより、ブラウザがページの再読み込みや戻る/進む操作時に自動的にスクロール位置を復元しなくなります。
  history.scrollRestoration = "manual";

  // ページがアンロード（閉じる、リロード、ナビゲートなど）される直前に実行されるイベントリスナーを追加します。
  window.addEventListener('beforeunload', function () {
    // ページがアンロードされる前にスクロール位置をページの先頭（0, 0）に設定します。
    window.scrollTo(0, 0);
  });



})();
export default funcReload;